import React, { CSSProperties, useState } from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

interface FadeRowData {
  title: string;
  desc: string;
  logo: string;
}

enum FadeRowActive {
  Null = 0,
  Left = 1,
  Right = 2,
}

export interface FadeRowProps {
  data: FadeRowData;
  className?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const FadeRowItem = ({ data: { title, desc, logo }, onMouseEnter, onMouseLeave, className }: FadeRowProps) => {
  return (
    <div className={cx('fade-row-item', className)} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className={cx('fade-row-item-info')}>
        <div className={cx('fade-row-item-title')}>{title}</div>
        <p className={cx('fade-row-item-desc')}>{desc}</p>
      </div>
      <div className={cx('fade-row-item-logo')}>
        <div className={cx('fade-row-item-logo-box')} style={{ backgroundImage: `url('${logo}')` }}></div>
      </div>
    </div>
  );
};

export const FadeRow = ({ left, right, style }: { left: FadeRowData; right: FadeRowData; style?: CSSProperties }) => {
  const [active, setActive] = useState(FadeRowActive.Null);
  return (
    <div className={cx('fade-row')} style={style}>
      <FadeRowItem
        data={left}
        className={{ active: active === FadeRowActive.Left, 'near-active': active === FadeRowActive.Right }}
        onMouseEnter={() => {
          setActive(FadeRowActive.Left);
        }}
        onMouseLeave={() => {
          setActive(FadeRowActive.Null);
        }}
      />
      <FadeRowItem
        data={right}
        className={{ active: active === FadeRowActive.Right, 'near-active': active === FadeRowActive.Left }}
        onMouseEnter={() => {
          setActive(FadeRowActive.Right);
        }}
        onMouseLeave={() => {
          setActive(FadeRowActive.Null);
        }}
      />
    </div>
  );
};

export default FadeRow;
